//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavAppsEdit(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 11H11V3H3V11ZM5 5H9V9H5V5Z" fill="currentColor" /><path d="M3 21H11V13H3V21ZM5 15H9V19H5V15Z" fill="currentColor" /><path d="M13 21H21V13H13V21ZM15 15H19V19H15V15Z" fill="currentColor" /><path d="M13 9.31577V11H14.6848L18.9219 6.76417L17.2372 5.07994L13 9.31577Z" fill="currentColor" /><path d="M19.3143 3L18.123 4.19092L19.8087 5.87607L21 4.68515L19.3143 3Z" fill="currentColor" /></svg>;
}
export default IconNavAppsEdit;